// @flow
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import CardThumbnail from 'components/fragments/card/CardThumbnail';
import CardSimple from 'containers/fragments/card/CardSimpleContainer';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

import type { CardType } from 'types/PageList';
import type { PageChildType } from 'types/PageNode';
import type { BlocContent } from 'types/NewsletterBloc';
import type { FullUserType } from 'types/User';

import { handleTagEvent } from 'utils/tagManagerUtils';

export type StateProps = {
  userPref: FullUserType
}

type Props = StateProps & {
  location: Location,
  liste_enfants: PageChildType[],
  content: BlocContent[],
};

class PageHubEntrepriseOffre extends Component<Props> {

  clickTagEvent = (offreName: string) => {
    const { userPref } = this.props;

    return handleTagEvent(
      'encart_offre',
      `clic ${offreName}`,
      '',
      userPref
    );
  }

  _renderCard = (card: CardType, index: number, parentIndex: number) => {
    const { location: { pathname } } = this.props;
    const className = this._getClassName[parentIndex][index];
    return (
      <div
        key={index}
        className={className}
        role='button'
        tabIndex={0}
        onClick={this.clickTagEvent(card.title)}>
        <CardThumbnail
          url={`${pathname}/${card.object_slug}`}
          backgroundUrl={card.featured_media}
          title={card.title}
          desc={card.description}
          linkLabel={card.texte_cta} />
      </div>
    );
  }

  _getClassName = {
    '0': {
      className: 'row mb-3 mb-md-4',
      title: 'mb-1',
      '0': 'col col-md-4 mb-2 mb-md-0',
      '1': 'col col-md-4 mb-2 mb-md-0',
      '2': 'col col-md-4',
    },
    '2': {
      className: 'row mb-5 mb-md-1 mb-lg-8',
      title: 'mb-3',
      '0': 'col col-md-4 mb-2 mb-md-5',
      '1': 'col col-md-4 mb-2 mb-md-5',
      '2': 'col col-md-4 mb-2 mb-md-5',
    },
  };

  _renderItem = (card: PageChildType) => {
    const { title, description, texte_cta, object_slug } = card;

    return (
      <CardSimple
        url={`${object_slug}`}
        title={title}
        desc={description}
        linkLabel={texte_cta} />
    );
  }

  _renderItems = (cards: Array<CardType>, parentIndex: number) => {
    const className = this._getClassName[parentIndex].className;

    const cardsContent = cards && cards.map((card, index) => {
      return this._renderCard(card, index, parentIndex);
    });

    return (
      <div className={className}>
        {cardsContent}
      </div>
    );
  }

  _renderDescription = (description: string) => (
    <p className="ft-secondary ft-black-secondary mb-5">{description}</p>
  );

  _renderContent = () => {
    const { liste_enfants } = this.props;

    const results = liste_enfants.map((blocContent, index) => {
      const { title, description, liste_enfants } = blocContent;
      if (index === 1) {
        return (
          <Fragment key={index}>
            {this._renderItem(blocContent)}
          </Fragment>
        );
      }

      const className = this._getClassName[index].title;

      return (
        <Fragment key={index}>
          {title && <h2 className={className}>{title}</h2>}
          {description && this._renderDescription(description)}
          {liste_enfants && this._renderItems(liste_enfants, index)}
        </Fragment>
      );
    });

    return results;
  }

  _renderBlocContent = () => {
    const { content } = this.props;
    return content.map((blocFigure, index) => {
      return (
          <ContentBloc key={index} {...blocFigure} />
      );
    });
  }

  render() {
    const { content } = this.props;
    
    return (
      <div className="page">
        {this._renderContent()}
        {content && 
          <div className="mb-6 mb-lg-8">
            {this._renderBlocContent()}
          </div>
        }
      </div>
    );
  }
}

export default withRouter(PageHubEntrepriseOffre);
